import _ from 'lodash';
import { isBlank } from 'utils';

// 保存时需要加上attributes后缀的字段
export const NEED_ADD_ATTRIBUTES_KEYS = [
  'supplier_contacts', 'service_info', 'bank_info', 'audit_user',
  'supplier_audits', 'supplier_contracts', 'supplier_employees', 'supplier_resources',
];

// 负责人、对接人
export const CONTRACTS_TYPES = ['leader', 'interface'];

export const TRANSLATE_MAPPING_KEYS = {
  status: {
    mapping_key: 'translated_status',
  },
  advance_payment: {
    mapping_key: 'translated_advance_payment',
  },
  service_type: {
    mapping_key: 'translated_service_type',
  },
  invoice_type: {
    mapping_key: 'translated_invoice_type',
  },
  supplier_type: {
    mapping_key: 'translated_supplier_type',
  },
};

export const BASIC_INFO_KEYS = {
  mpc_no: {
    label: 'mpc_no',
    required: true,
    componentClass: 'input',
  },
  full_name: {
    label: 'full_name',
    required: true,
    componentClass: 'input',
  },
  short_name: {
    label: 'short_name',
    required: true,
    componentClass: 'input',
  },
  status: {
    label: 'status',
    required: true,
    componentClass: 'radio',
    optionsKey: 'statuses',
  },
  supplier_type: {
    label: 'supplier_type',
    required: true,
    componentClass: 'select',
    optionsKey: 'supplier_types',
  },
  region: {
    label: 'region',
    required: true,
    componentClass: 'autocomplete',
    optionsKey: 'regions',
  },
  advance_payment: {
    label: 'advance_payment',
    required: true,
    componentClass: 'select',
    optionsKey: 'advance_payments',
  },
  parent_company: {
    label: 'parent_company',
    required: false,
    tip: 'parent_company_tips',
    componentClass: 'autocomplete',
    optionsKey: 'parent_companies',
  },
  address: {
    label: 'address',
    required: false,
    componentClass: 'input',
  },
  service_type: {
    label: 'service_type',
    required: true,
    componentClass: 'select',
    optionsKey: 'service_types',
  },
  service_content: {
    label: 'service_content',
    required: false,
    componentClass: 'input',
  },
};

export const AUDIT_INFO_KEYS = {
  user_name: {
    label: 'user_name',
    componentClass: 'span',
    itemColProps: { sm: 6, md: 4 },
    itemColProps_show: { sm: 6, md: 5 },
  },
  audit_at: {
    label: 'audit_at',
    componentClass: 'span',
    itemColProps: { sm: 6, md: 4 },
    itemColProps_show: { sm: 6, md: 5 },
  },
  remark: {
    label: 'remark',
    componentClass: 'textarea',
    itemColProps: { sm: 12, md: 16 },
    itemColProps_show: { sm: 6, md: 14 },
  },
};

export const SUPPLIER_CONTRACTS_KEYS = {
  name: {
    label: ['leader_name', 'interface_name'],
    componentClass: 'input',
    formItemKey: 'supplier_contacts.name',
    componentProps: {
      maxHeight: 32,
    },
  },
  job_title: {
    label: 'job_title',
    componentClass: 'input',
    formItemKey: 'supplier_contacts.job_title',
    componentProps: {
      maxHeight: 32,
    },
  },
  email: {
    label: 'email',
    componentClass: 'input',
    formItemKey: 'supplier_contacts.email',
    componentProps: {
      maxHeight: 32,
    },
  },
  telephone: {
    label: 'telephone',
    componentClass: 'input',
    formItemKey: 'supplier_contacts.telephone',
    componentProps: {
      maxHeight: 32,
    },
  },
};

export const BANK_INFO_KEYS = {
  bank_name: {
    label: 'bank_name',
    componentClass: 'input',
  },
  bank_number: {
    label: 'bank_number',
    componentClass: 'input',
  },
  invoice_type: {
    label: 'invoice_type',
    componentClass: 'radio',
    optionsKey: 'invoice_types',
  },
};

export const SERVICE_INFO_KEYS = {
  supplier_resources: {
    componentClass: 'treeSelect',
    optionsKey: 'superior_resources',
    componentProps: {
      isMultiple: true,
      treeCheckable: true,
      typeConfig: {
        multiple: { showSelectAllOption: true, hideConfirmButton: true },
      },
    },
    showProps: {
      itemColProps: { span: 3 },
      render: (data: any) => {
        const supplierResources = _.get(data, 'supplier_resources', []);
        return supplierResources.map((i: any) => i && i.name).join(',') || '--';
      },
    },
    editProps: {
      itemColProps: { span: 5 },
      formKey: 'supplier_resources',
      // 后端返回的不是标准的value格式，树形结构的value需要特殊处理
      getValue: (value: any) => {
        return value ?
          value.filter((i: any) => !i._destroy).map((i: any) => i.superior_resource_id) :
          [];
      },
    },
  },
  customer_name: {
    componentClass: 'textarea',

    showProps: {
      itemColProps: { span: 4 },
    },
    editProps: {
      itemColProps: { span: 5 },
      formKey: 'service_info.customer_name',
    },
  },
  case_digest: {
    componentClass: 'textarea',
    showProps: {
      itemColProps: { span: 6 },
    },
    editProps: {
      itemColProps: { span: 5 },
      formKey: 'service_info.case_digest',
    },
  },
  netease_case_digest: {
    componentClass: 'textarea',
    showProps: {
      itemColProps: { span: 7 },
    },
    editProps: {
      itemColProps: { span: 5 },
      formKey: 'service_info.netease_case_digest',
    },
  },
  total_employee: {
    required: true,
    componentClass: 'input',
    showProps: {
      itemColProps: { span: 4 },
    },
    editProps: {
      itemColProps: { span: 4 },
      formKey: 'service_info.total_employee',
    },
  },
};

export const getRequiredKeys = (items: any, prefix: string = ''): any => {
  const res = {};
  Object.keys(items).forEach((key: string) => {
    if (items[key].required) {
      const newKey = prefix ? `${prefix}.${key}` : key;
      res[newKey] = items[key].label;
    }
  });
  return res;
};

export const ALL_REQUIRED_KEYS = {
  ...getRequiredKeys(BASIC_INFO_KEYS),
  ...getRequiredKeys(SERVICE_INFO_KEYS, 'service_info'),
  ...getRequiredKeys(BANK_INFO_KEYS, 'bank_info'),
};

export const CELL_NON_VALUE = '--';

export const SELECT_SINGLE_CONFIG = {
  single: { showSelectNoOption: true, selectNoOptionName: 'selectAll' },
};

export const FILTER_CONFIG = [{
  key: 'status',
  type: 'select',
  elementProps: {
    isMultiple: true,
    searchEnable: false,
    typeConfig: {
      multiple: { showSelectAllOption: true },
    },
    mode: 'filter',
  },
}, {
  key: 'supplier_type',
  type: 'select',
  elementProps: {
    isMultiple: true,
    searchEnable: false,
    typeConfig: {
      multiple: { showSelectAllOption: true },
    },
    mode: 'filter',
  },
}, {
  key: 'service_type',
  type: 'select',
  elementProps: {
    isMultiple: true,
    searchEnable: false,
    typeConfig: {
      multiple: { showSelectAllOption: true },
    },
    mode: 'filter',
  },
}, {
  key: 'region',
  type: 'select',
  elementProps: {
    isMultiple: true,
    searchEnable: false,
    typeConfig: {
      multiple: { showSelectAllOption: true },
    },
    mode: 'filter',
  },
}, {
  key: 'advance_payment',
  type: 'select',
  elementProps: {
    typeConfig: SELECT_SINGLE_CONFIG,
  },
}];

export const LIST_COLUMNS = {
  full_name: {
    title: 'full_name',
    width: 250,
    align: 'left',
  },
  short_name: {
    title: 'short_name',
    align: 'left',
    width: 126,
  },
  translated_status: {
    title: 'status',
    width: 112,
  },
  translated_supplier_type: {
    title: 'supplier_type',
    width: 136,
  },
  translated_service_type: {
    title: 'service_type',
    width: 206,
  },
  service_info: {
    title: 'total_employee',
    width: 125,
  },
  supplier_contacts: {
    title: 'interface_name',
    width: 226,
    align: 'left',
  },
  region: {
    title: 'region',
    width: 120,
  },
  translated_advance_payment: {
    title: 'advance_payment',
    width: 120,
  },
  recommend_group_name: {
    title: 'recommend_group_name',
    width: 136,
    align: 'left',
  },
  updated_at: {
    title: 'updated_at',
    width: 135,
  },
  operation: {
    title: 'operation',
    width: 185,
    fixed: 'right',
  },
};

export const STATUS_COLORS_MAPPING = {
  'active': 'green',
  'pending': 'orange',
  'locked': 'beige',
  'rejected': 'grey',
  '': 'beige',
};

export const EN_ITEM_COL = {
  customer_name: {
    itemColProps: { span: 4 },
  },
  case_digest: {
    itemColProps: { span: 4 },
  },
  netease_case_digest: {
    itemColProps: { span: 5 },
  },
  total_employee: {
    itemColProps: { span: 3 },
  },
  recommend_group_name: {
    itemColProps: { span: 3 },
  },
  referrer_name: {
    itemColProps: { span: 2 },
  },
  recommend_reason: {
    itemColProps: { span: 3 },
  },
};

export const localeColAttr = {
  en: EN_ITEM_COL,
};

export const EN_TABLE_WIDTH = {
  parent_cate: {
    width: '18%',
  },
  cate: {
    width: '27%',
  },
  info: {
    width: '43%',
  },
  status: {
    width: '12%',
  },
};

export const localTableAttr = {
  en: EN_TABLE_WIDTH,
};

export const EN_COLUMNS = {
  full_name: {
    width: 220,
  },
  short_name: {
    width: 130,
  },
  translated_supplier_type: {
    width: 185,
  },
  translated_advance_payment: {
    width: 170,
  },
  recommend_group_name: {
    width: 240,
  },
  updated_at: {
    width: 165,
  },
  operation: {
    width: 140,
  },
  translated_service_type: {
    width: 195,
  },
};

export const localeColumnsAttr = {
  en: EN_COLUMNS,
};

const COMMON_ELEMENT_PROPS = {
  isMultiple: true,
  searchEnable: false,
  typeConfig: {
    multiple: { showSelectAllOption: true },
  },
  mode: 'filter',
};

export const SM_FILTER_CONFIG = [{
  key: 'status',
  type: 'select',
  elementProps: COMMON_ELEMENT_PROPS,
}, {
  key: 'supplier_type',
  type: 'select',
  elementProps: COMMON_ELEMENT_PROPS,
}, {
  key: 'superior_resources',
  type: 'select',
  elementProps: {
    ...COMMON_ELEMENT_PROPS,
    isTree: true,
    treeCheckable: true,
  },
}, {
  key: 'region',
  type: 'select',
  elementProps: COMMON_ELEMENT_PROPS,
}, {
  key: 'advance_payment',
  type: 'select',
  elementProps: {
    typeConfig: SELECT_SINGLE_CONFIG,
  },
}];

export const SM_LIST_COLUMNS = {
  ...LIST_COLUMNS,
  translated_service_type: {
    title: 'service_type',
    width: 160,
  },
  service_info: {
    title: 'total_employee',
    width: 160,
  },
  operation: {
    title: 'operation',
    width: 165,
    align: 'center',
    fixed: 'right',
  },
  superior_resources: {
    title: 'superior_resources',
    width: 180,
  },
};

export const SUPPLIER_EMPLOYEES_KEYS_MAPPING = {
  user_login: {
    name: 'user_login',
    showProps: {
      align: 'left',
    },
    editProps: {
      align: 'left',
    },
  },
  status: {
    name: 'status',
    showProps: {
      align: 'left',
    },
    editProps: {
      required: true,
      align: 'left',
      componentClass: 'checkbox',
    },
  },
  user_name: {
    name: 'user_name',
    showProps: {
      align: 'left',
    },
    editProps: {
      required: true,
      align: 'left',
      componentClass: 'input',
    },
  },
  user_email: {
    name: 'user_email',
    showProps: {
      align: 'left',
    },
    editProps: {
      // required: true,
      disabled: true,
      align: 'left',
      componentClass: 'input',
    },
  },
  user_popo: {
    name: 'user_popo',
    showProps: {
      align: 'left',
    },
    editProps: {
      align: 'left',
      componentClass: 'input',
    },
  },
  user_password: {
    name: 'user_password',
    tooltip: 'userPasswordTooltip',
    showProps: {
      align: 'left',
    },
    editProps: {
      align: 'left',
      componentClass: 'inputPassword',
      placeholder: 'userPasswordPlaceholder',
      type: 'password',
      maxLength: 16,
    },
  },
};

export const SUPPLIER_CONTRACTS_KEYS_MAPPING = {
  currency: {
    componentClass: 'select',
    optionsKey: 'currencies',
    editProps: {
      itemKey: 'currency',
      itemColProps: { sm: 10, xxxl: 4 },
      required: true,
    },
  },
  translated_currency: {
    showProps: {
      itemColProps: { span: 5 },
    },
  },
  translated_invoice_type: {
    showProps: {
      itemColProps: { span: 6 },
    },
  },
  'bank_info.invoice_type': {
    componentClass: 'radio',
    optionsKey: 'invoice_types',
    componentProps: {

    },
    editProps: {
      itemKey: 'bank_info.invoice_type',
      itemColProps: { sm: 14, xxxl: 10 },
      required: true,
    },
  },
  contract_begin_at: {
    componentClass: 'datePicker',
    editProps: {
      itemKey: 'contract_begin_at',
      itemColProps: { sm: 10, xxxl: 5 },
    },
  },
  contract_end_at: {
    componentClass: 'datePicker',
    editProps: {
      itemKey: 'contract_end_at',
      itemColProps: { sm: 10, xxxl: 5 },
    },
  },
  code: {
    componentClass: 'input',
  },
  upper_limit: {
    componentClass: 'input',
  },
  balance: {

  },
  gz: {

  },
  hz: {

  },
  sh: {

  },
  hk: {

  },
};

export const getFormattedBankNumber = (num: string) => {
  if (!isBlank(num)) {
    const reg = /\d{0,4}/g;
    const match: RegExpMatchArray | null = num.match(reg);
    if (match) {
      return match.join(' ').trim();
    }
  }
  return num;
};
